export default __webpack_public_path__ + "static/media/profile-liked-me-grey.6d5dc633.svg";